import styled from "styled-components";

export const Container = styled.footer`
	@media screen and (min-width: 0px) {
		padding: 20px 0;
		box-shadow: 0px -4px 15px 3px rgba(0, 0, 0, 0.1);

		.footer {
			display: flex;
			flex-direction: column;

			.footer__header {
				display: flex;
				align-items: center;
				margin-bottom: 15px;

				.separator-right {
					border-right: 2px solid #ccc;
					padding-right: 15px;
					margin-right: 15px;

					img {
						width: 130px;
						height: 35px;
					}
				}

				.social-midia {
					flex: 1 1 0;
					display: flex;
					img + img {
						margin-left: 10px;
					}
				}
			}

			.footer__copy {
				display: flex;
				align-items: center;

				.copyright {
					font-size: 0.75em;

					a {
						font-size: 0.75rem;
					}
				}

				.btn-top {
					border: 0;
					background: none;

					.go-top {
						width: 35px;
						height: 35px;
						outline: none;
					}

					&:focus,
					&:active,
					&:visited {
						outline: none;
					}
				}
			}
		}
	}

	@media screen and (min-width: 992px) {
		.footer {
			flex-direction: row;
			align-items: center;
			justify-content: space-between;

			.footer__header {
				margin-bottom: 0;
			}

			.footer__copy {
				flex: 1 1 auto;
				display: flex;
				align-items: center;
				justify-content: space-between;
				margin-left: 15px;

				.copyright {
					margin-left: 30px;
				}
			}
		}
	}
`;
